import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHandbook } from '~/hooks';

interface Props {
  options?: { label?: string; value: any }[];
  currencyFilter?: (currency: string) => boolean;
  className?: string;
  [x: string]: any;
}

const CurrencyInput: FC<Props> = (props) => {
  const { options, currencyFilter, ...rest } = props;
  const { t } = useTranslation('transactions');
  const { data, isLoading } = useHandbook();
  const solutionCurrencies: Props['options'] =
    data?.currencies?.map((item: any) => ({
      label: item.name,
      value: item.id,
    })) || [];

  let allOptions = options || solutionCurrencies;
  if (currencyFilter) {
    allOptions = allOptions?.filter((option) => currencyFilter(option.value));
  }

  return (
    <Select
      placeholder={t('currency')}
      options={allOptions}
      filterOption={(inputValue, option) =>
        (option?.label as string)?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
      }
      showSearch
      disabled={isLoading}
      allowClear
      {...rest}
    />
  );
};

export default CurrencyInput;
